module.exports = __webpack_public_path__ + "resource/img/personal-man-active.a2d6a38b.svg";